import axios from 'axios'
import store from './state/store'

//const baseUrlLocal = 'http://localhost:8000/api/'
const serverURL = 'https://posbackend.metacoresystemsinc.com/api/'

const axiosInstance = axios.create({
  baseURL: serverURL
})

axiosInstance.interceptors.request.use(
  (config) => {
    const token = store.state.accessToken
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default axiosInstance